<template>
	<div>
		<div class="attend-card-wrapper px-4 py-4 mb-4">
			<Avatar class="mr-4 post-preview-card__avatar" size="85" :avatar="user.user_logo" />

			<div>
				<div class="attend-card-tittle">
					{{ user.visible_username }}
				</div>
				<div class="attend-card-location">
					{{ user.location_profile_row }}
				</div>
				<div class="attend-card-description">
					{{ user.second_profile_row }}
				</div>
				<div class="attend-card-description">
					{{ user.third_profile_row }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar'

Vue.use(VueScrollTo)

export default {
	name: 'AttendCard',

	components: {
		Avatar,
	},
	props: {
		user: {
			type: Object,
			default: () => {},
		},
	},
}
</script>

<style lang="scss">
.attend-card {
	&-wrapper {
		display: flex;
		background: rgb(251, 251, 251);
		border: 1px solid rgb(226, 226, 226);
		border-radius: 12px;
	}

	&-logo {
		width: 25%;
		object-fit: contain;
		margin-right: 10px;
	}
	&-tittle {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat;
		font-weight: bold;
	}

	&-location {
		display: flex;
		color: #808080;
		font-size: 13px;
		font-family: Montserrat;
		font-weight: 600;
		letter-spacing: 0px;
		line-height: 17px;
	}
	&-description {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat;
		font-weight: normal;
		line-height: 20px;
	}
}
</style>
